import { Cloud, CreateCloud } from "@app/types";
import HttpService from "@core/services/http/http.service";

class _CloudService {
  /** silent: cập nhật lại trạng thái Còn máy / Hết máy ở nền, không hiện loading / toast */
  public getClouds(silent = false) {
    return HttpService.get<Cloud[]>("/clouds", { silent });
  }

  /** Trạng thái Còn máy / Hết máy của các gói (server giữ kết quả 10s), trang Cloud hỏi lại mỗi 5s ở nền */
  public getAvailability() {
    return HttpService.get<Pick<Cloud, "_id" | "cloudReady">[]>("/clouds/availability", { silent: true });
  }
}

const CloudService = new _CloudService();

export default CloudService;
